var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_7551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_7551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9937 20.9844C30.9937 21.5469 30.525 21.9875 29.9937 21.9875H28.9937L29.0156 26.9937C29.0156 27.0781 29.0094 27.1625 29 27.2469V27.75C29 28.4406 28.4406 29 27.75 29H27.25C27.2156 29 27.1813 29 27.1469 28.9969C27.1031 29 27.0594 29 27.0156 29H26H25.25C24.5594 29 24 28.4406 24 27.75V27V25C24 24.4469 23.5531 24 23 24H21C20.4469 24 20 24.4469 20 25V27V27.75C20 28.4406 19.4406 29 18.75 29H18H17.0031C16.9563 29 16.9094 28.9969 16.8625 28.9937C16.825 28.9969 16.7875 29 16.75 29H16.25C15.5594 29 15 28.4406 15 27.75V24.25C15 24.2219 15 24.1906 15.0031 24.1625V21.9875H14C13.4375 21.9875 13 21.55 13 20.9844C13 20.7031 13.0938 20.4531 13.3125 20.2344L21.325 13.25C21.5437 13.0312 21.7937 13 22.0125 13C22.2312 13 22.4812 13.0625 22.6687 13.2188L30.65 20.2344C30.9 20.4531 31.025 20.7031 30.9937 20.9844Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_7551",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_7551"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_7551",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_7551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveHome);
export default __webpack_public_path__ + "static/media/ic_active_home.440b2bd807b7731df952219c66210813.svg";
export { ForwardRef as ReactComponent };